import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import { initGA, trackPageView } from "@/lib/analytics";

import LandingPage from "@/pages/LandingPage";
import { LoginPage, SignupPage } from "@/pages/AuthPages";
import DashboardPage from "@/pages/DashboardPage";
import CreateWizard from "@/pages/CreateWizard";
import ComicReaderPage from "@/pages/ComicReaderPage";
import { PricingPage, PaymentSuccessPage } from "@/pages/PaymentPages";
import TeacherDashboard from "@/pages/TeacherDashboard";
import SharedComicPage from "@/pages/SharedComicPage";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-12 text-center font-body font-bold">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  return null;
}

function App() {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <RouteTracker />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/payment-success" element={<PaymentSuccessPage />} />
            <Route path="/dashboard" element={<Protected><DashboardPage /></Protected>} />
            <Route path="/teacher" element={<Protected><TeacherDashboard /></Protected>} />
            <Route path="/create" element={<Protected><CreateWizard /></Protected>} />
            <Route path="/comic/:id" element={<Protected><ComicReaderPage /></Protected>} />
            <Route path="/shared/:token" element={<SharedComicPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
